if (!customElements.get('model-view-switch')) {
  customElements.define('model-view-switch', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery') || document.getElementById(this.dataset.gallery);
      this.input = this.querySelector('input');
      if (!this.gallery || !this.input) return;
      this.selection ||= this.dataset.default === 'woman' ? 'woman' : 'man';
      const peer = this.peers().find(control => control !== this && control.selection);
      if (peer) this.selection = peer.selection;
      this.onChange ||= () => this.selectView(this.input.checked ? 'woman' : 'man');
      this.onClick ||= event => {
        const button = event.target.closest('[data-model-choice]');
        if (button && this.contains(button)) this.selectView(button.dataset.modelChoice);
      };
      this.input.addEventListener('change', this.onChange);
      this.onPointerFocus ||= () => this.input.setAttribute('data-pointer-focus', '');
      this.onKeyboardFocus ||= () => this.input.removeAttribute('data-pointer-focus');
      this.input.addEventListener('pointerdown', this.onPointerFocus);
      this.input.addEventListener('keydown', this.onKeyboardFocus);
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.refresh());
      const track = this.gallery.querySelector('[id^="Slider-Gallery-"]');
      if (track) this.observer.observe(track, {childList:true});
      this.refresh();

    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.input?.removeEventListener('change', this.onChange);
      this.input?.removeEventListener('pointerdown', this.onPointerFocus);
      this.input?.removeEventListener('keydown', this.onKeyboardFocus);
      this.removeEventListener('click', this.onClick);
    }
    peers() {
      return [...document.querySelectorAll('model-view-switch')].filter(control =>
        (control.dataset.gallery || control.closest('media-gallery')?.id) ===
        (this.dataset.gallery || this.closest('media-gallery')?.id));
    }
    selectView(view) {
      this.peers().forEach(control => { control.selection = view; control.refresh(control === this); });
    }
    refresh(announce = false) {
      // Colour filtering replaces the gallery element while the title control stays.
      const currentGallery = this.closest('media-gallery') || document.getElementById(this.dataset.gallery);
      if (currentGallery !== this.gallery) {
        this.gallery = currentGallery;
        this.observer?.disconnect();
        const nextTrack = this.gallery?.querySelector('[id^="Slider-Gallery-"]');
        if (nextTrack) this.observer?.observe(nextTrack, {childList:true});
      }
      const track = this.gallery?.querySelector('[id^="Slider-Gallery-"]');
      if (!track) return;
      const slides = [...track.children].filter(item => item.hasAttribute('data-media-id'));
      const groups = new Set(slides.map(item => item.dataset.modelView).filter(Boolean));
      this.hidden = !(groups.has('man') && groups.has('woman'));
      // Keep the preference for the next colour, but never create an empty view.
      const effective = groups.has(this.selection) ? this.selection : (groups.has('man') ? 'man' : 'woman');
      this.input.checked = effective === 'woman';
      this.querySelectorAll('[data-model-label]').forEach(label => label.classList.toggle('is-selected', label.dataset.modelLabel === effective));
      this.querySelectorAll('[data-model-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.modelChoice === effective)));
      this.gallery.querySelectorAll('[data-model-caption]').forEach(caption => {
        const modelCaption = groups.size ? caption.getAttribute(`data-caption-${effective}`) : '';
        const text = modelCaption || caption.dataset.captionDefault || '';
        caption.textContent = text;
        caption.title = text;
        caption.hidden = !text;
      });
      const apply = item => {
        const group = item.dataset.modelView;
        item.hidden = !!group && group !== effective;
        if (item.hidden) {
          item.querySelectorAll('video').forEach(video => video.pause());
          // Use the existing media pause API for embedded video/3D players.
          if (item.querySelector('iframe, model-viewer')) window.pauseAllMedia?.();
        }
      };
      slides.forEach(apply);
      const thumbs = this.gallery.querySelector('[id^="Slider-Thumbnails-"]');
      if (thumbs) [...thumbs.children].forEach(apply);
      const section = this.gallery.id.replace('MediaGallery-', '');
      document.getElementById(`ProductModal-${section}`)?.querySelectorAll('[data-model-view]').forEach(apply);
      const visible = slides.filter(item => !item.hidden);
      if (thumbs) [...thumbs.children].forEach(thumb => {
        const position = visible.findIndex(item => item.dataset.mediaId === thumb.dataset.target);
        if (position >= 0) thumb.dataset.mediaPosition = String(position + 1);
      });
      const active = visible.find(item => item.classList.contains('is-active')) || visible[0];
      if (active) this.gallery.setActiveMedia?.(active.dataset.mediaId, false, true);
      this.gallery.elements?.viewer?.resetPages?.();
      this.gallery.updateDesktopCounter?.();
      if (announce) this.querySelector('[data-model-status]').textContent = this.querySelector(`[data-model-label="${effective}"]`).textContent;
    }
  });
}
